import { Pagination, Paper } from "@mui/material";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import { Modal } from "antd";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomModal from "../../../Components/CustomModal";
import Loader from "../../../Components/Loader";
import TableTopView from "../../../Components/TableTopView";
import Strings from "../../../Config/Strings";
import { deletePageDetailsAPI, deletepageDetailsAPI } from "../../../Store/Action/page";
import { TableWrapper } from "../../../Utils/CommonStyles/muTableStyle";
import PageTableHeader from "./Controls/PageTableHeader";
import PageTableBody from "./Controls/PageTableBody";



const PageTable = ({ page }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [pageIdToDelete, setpageIdToDelete] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);

    const handleOpen = useCallback(() => setModalVisible(true), []);
    const handleClose = useCallback(() => setModalVisible(false), []);
    const handleCancelDelete = useCallback(() => setShowDeleteModal(false), []);
  
    const handleShowDeleteModal = useCallback((pageId) => {
      setpageIdToDelete(pageId);
      setShowDeleteModal(true);
    }, []);
  
    const onAddpage = useCallback(() => {
      navigate("/AddPage");
    }, [navigate]);
  
    const onViewpageDetails = useCallback(
      (pageId) => {
        navigate(`/page/${pageId?.page_id}`, { state: { pageId } });
      },
      [navigate]
    );
  
    const onEditpageDetails = useCallback(
      (editpage) => {
        navigate(`/page/edit`, { state: { editpage } });
      },
      [navigate]
    );
  
    const handleDeletepage = async () => {
     
      setLoading(true);
      try {
        await dispatch(
          deletePageDetailsAPI(pageIdToDelete, (isSuccess, response) => {
            setShowDeleteModal(false);
            setLoading(false);
            if (isSuccess?.status === true) {
              toast.success(response?.data?.message);
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else {
              const errorMessage =
                response?.error?.message || Strings.somethingWentWrongError;
              toast.error(errorMessage);
            }
          })
        );
      } catch (error) {
        console.log("Error dispatching deletepageDetailsAPI:", error);
        setLoading(false);
        toast.error(Strings.somethingWentWrongError);
      }
    };

    return (
      <div style={mainContainer}>
        <TableContainer component={Paper} style={tableContainer}>
          <TableTopView
            exportBtnTxt={"Export page"}
            addBtnTxt={"Add page"}
            onExportBtnPress={handleOpen}
            onAddButton={onAddpage}
          />
  
          <TableWrapper>
            <Table stickyHeader aria-label="customized table">
              <PageTableHeader/>
              <PageTableBody
                pageDetails={page}
                onViewpageDetails={onViewpageDetails}
                onEditpageDetails={onEditpageDetails}
                handleShowDeleteModal={handleShowDeleteModal}
              />
            </Table>
          </TableWrapper>
  
          <Modal
            title="Confirm Delete"
            visible={showDeleteModal}
            onOk={handleDeletepage}
            onCancel={handleCancelDelete}
          >
            <p>{Strings.deleteProductMetalConfirmation}</p>
          </Modal>
  
          <CustomModal
            YesBtnText={Strings.ExportExcel}
            NoBtnText={Strings.ExportPDF}
            headingTxt={Strings.ExportOptions}
            handleClose={handleClose}
            modalVisible={modalVisible}
          />
        </TableContainer>
  
        <Loader loading={loading} />
      </div>
    );
};

const mainContainer = {
  backgroundColor: "white",
  width: "100%",
  height: "100vh",
  paddingTop: "20px",
  marginTop: "15px",
  border: "0.5px solid #ffff",
  borderRadius: "10px",
  marginLeft: "20px",
};

const tableContainer = {
  width: "72vw",
  border: "1px solid #ccc",
  borderRadius: "20px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "5px",
  paddingLeft: "20px",
  paddingRight: "20px",
  marginLeft: "30px",
  padding: "10px",
};

export default PageTable;
